"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reserve = exports.Liabilities = exports.CommitmentAmount = exports.MaximumPrefundingAmount = exports.CashAdvanceRate = exports.ResolvedCalcAgentMechanicsConfigSchema = exports.LoanTapeField = exports.ReceivableAdvanceRate = exports.ReceivableValuationRate = exports.PurchasePercentageRate = exports.Reporting = exports.FinancialCovenant = exports.PortfolioCovenant = exports.CommonIntermediateFieldSchema = exports.FinancialCovenantPostgresQuerySchema = exports.AssetVerificationQuerySchema = exports.OrgProvidedInputQuerySchema = exports.TAccountsSumQuerySchema = exports.PrincipalBalanceDailyAverageQuerySchema = exports.PrincipalBalancePointInTimeQuerySchema = exports.PostgresParameterReportingPeriodConfigSchema = exports.PostgresParameterOrgProvidedInputKeyConfigSchema = exports.PostgresParameterTAccountsSumConfigSchema = exports.PostgresParameterCapitalProviderSlugsConfigSchema = exports.PostgresParameterAssetVerificationStatusConfigSchema = exports.PostgresParameterFormulaConfigSchema = exports.CommonPostgresQuery = exports.CommonFacilityMetricsQuery = exports.ReportingInputsIntermediateFieldSchema = exports.AthenaConfigRecurringQuerySchema = exports.AthenaConfigQuerySchema = exports.QueryResultSchema = exports.QueryVariableSchema = exports.GlobalRecurringDate = exports.ConcentrationLimit = exports.EligibilityTest = exports.DeliverableReportProperty = exports.DeliverablePropertyDEPRECATED = exports.DeliverableArtifactProperty = exports.DeliverableProperty = exports.LoanProductMechanics = exports.FullFormulaConfigSchema = exports.FormulaConfigSchema = void 0;
const AssetVerification = __importStar(require("../AssetVerification"));
const Date_1 = require("../Date");
const DbTables_1 = require("../DbTables");
const Deliverable = __importStar(require("../Deliverable"));
const FormulaEngine = __importStar(require("../FormulaEngine"));
const Notifications = __importStar(require("../Notifications"));
const Report = __importStar(require("../Report"));
const Utils = __importStar(require("../Utils"));
const DataTapeField_1 = require("./DataTapeField");
const z = __importStar(require("zod"));
// signature for a function that handles custom cash balance csv
// and converts to standard record.
exports.FormulaConfigSchema = z.object({
    engineVersion: z.enum(FormulaEngine.SupportedFormulaEngines),
    formula: z.string(),
});
exports.FullFormulaConfigSchema = z.object({
    engineVersion: z.enum(FormulaEngine.FullSupportedFormulaEngines),
    formula: z.string(),
});
var LoanProductMechanics;
(function (LoanProductMechanics) {
    LoanProductMechanics.VintageCurveFormulaDenominatorTypeIterable = [
        'normalizedInitialBalance',
        'exposure',
    ];
    // Zod schemas for LoanProductMechanics.Config
    // Note: These reference schemas that are defined later in the file, so we use lazy loading
    const AssignedLoanTapeCsvConfigSchema = z.object({
        type: z.enum(['include', 'exclude']),
        fields: z.array(z.string()),
    });
    const AssignedLoanTapeCsvConfigsSchema = z.object({
        extendedResponseTape: AssignedLoanTapeCsvConfigSchema.optional(),
        rawAssigned: AssignedLoanTapeCsvConfigSchema.optional(),
        generatedAssigned: AssignedLoanTapeCsvConfigSchema.optional(),
    });
    // ConfigSchema for LoanProductMechanics - uses lazy references for schemas defined later
    LoanProductMechanics.ConfigSchema = z.object({
        externalReceivableIdField: z.string(),
        rawExternalReceivableIdField: z.string().optional(),
        baseFieldConfigs: DataTapeField_1.DataTapeField.BaseConfigSchema.array(),
        intermediateCalcConfigs: z
            .lazy(() => LoanTapeField.IntermediateCalcs.IntermediateCalcContainerSchema)
            .array(),
        signaledExternalAssignment: z
            .lazy(() => LoanTapeField.SignaledExternalAssignmentContainerSchema)
            .optional(),
        vintageCurveFormulaDenominator: z.enum(LoanProductMechanics.VintageCurveFormulaDenominatorTypeIterable),
        assignedLoanTapeCsvConfigs: AssignedLoanTapeCsvConfigsSchema,
    });
})(LoanProductMechanics || (exports.LoanProductMechanics = LoanProductMechanics = {}));
/**
 * ============= DELIVERABLES =============
 */
var DeliverableProperty;
(function (DeliverableProperty) {
    DeliverableProperty.ConfigSchema = z.object({
        configKey: z.string(),
        daysOffset: z.number(),
        recurringDueDateConfig: Date_1.RecurringDate.ConfigSchema,
    });
})(DeliverableProperty || (exports.DeliverableProperty = DeliverableProperty = {}));
var DeliverableArtifactProperty;
(function (DeliverableArtifactProperty) {
    // Zod schemas for DeliverableArtifactProperty.Config
    const BaseConfigSchema = z.object({
        type: z.enum(Deliverable.DeliverableTypes),
        configKey: z.string(),
        relativeRecurringDateConfig: Date_1.RecurringDate.RelativeConfigSchema,
    });
    const SupplementalTapeConfigSchema = BaseConfigSchema.extend({
        type: z.literal('supplementalTape'),
        artifactSlug: z.string(),
    });
    const MonthlyServicerReportConfigSchema = BaseConfigSchema.extend({
        type: z.literal('monthlyServicerReportXlsx'),
        reportName: z.string(),
    });
    const CashBalancesFeedConfigSchema = BaseConfigSchema.extend({
        type: z.literal('cashBalancesFeed'),
    });
    const RepaymentTapeConfigSchema = BaseConfigSchema.extend({
        type: z.literal('repaymentTape'),
        loanProductSlug: z.string(),
    });
    const LoanTapeConfigSchema = BaseConfigSchema.extend({
        type: z.literal('loanTape'),
        loanProductSlug: z.string(),
    });
    const PortfolioCovenantConfigSchema = BaseConfigSchema.extend({
        type: z.literal('portfolioCovenant'),
        covenantKey: z.string(),
    });
    const FinancialCovenantConfigSchema = BaseConfigSchema.extend({
        type: z.literal('financialCovenant'),
        covenantKey: z.string(),
    });
    const OrgProvidedInputConfigSchema = BaseConfigSchema.extend({
        type: z.literal('orgProvidedInput'),
        key: z.string(),
        artifactSlug: z.string().optional(),
    });
    const MonthlyStatementConfigSchema = BaseConfigSchema.extend({
        type: z.literal('monthlyStatement'),
        reportingPeriodStartDateFormula: z.string(),
        reportingPeriodEndDateFormula: z.string(),
    });
    const FinancialStatementConfigSchema = BaseConfigSchema.extend({
        type: z.literal('financialStatement'),
        artifactSlug: z.string(),
        financialDataArtifactSlug: z.string(),
    });
    DeliverableArtifactProperty.ConfigSchema = z.discriminatedUnion('type', [
        SupplementalTapeConfigSchema,
        MonthlyServicerReportConfigSchema,
        CashBalancesFeedConfigSchema,
        RepaymentTapeConfigSchema,
        LoanTapeConfigSchema,
        PortfolioCovenantConfigSchema,
        FinancialCovenantConfigSchema,
        OrgProvidedInputConfigSchema,
        MonthlyStatementConfigSchema,
        FinancialStatementConfigSchema,
    ]);
})(DeliverableArtifactProperty || (exports.DeliverableArtifactProperty = DeliverableArtifactProperty = {}));
var DeliverablePropertyDEPRECATED;
(function (DeliverablePropertyDEPRECATED) {
    // @jendevelops TODO: add in slack notification
    DeliverablePropertyDEPRECATED.PreUploadNotificationTypes = [
        Notifications.BorrowerEmailType.deliverablesResponsiblePartyReminder,
        Notifications.BorrowerEmailType.deliverablesResponsiblePartyStatusUpdate,
    ];
    DeliverablePropertyDEPRECATED.PostUploadNotificationTypes = [
        Notifications.BorrowerEmailType
            .deliverablesResponsiblePartySubmitSubmission,
    ];
    // Zod schemas for DeliverablePropertyDEPRECATED.Config
    const PartyPermissionSchema = z.object({
        _id_: z.string(),
        permissionTypes: z.array(z.enum(Deliverable.v3DEPRECATED.PremissionTypes)),
    });
    const PreUploadNotificationProcessSchema = z.object({
        notificationType: z.enum(DeliverablePropertyDEPRECATED.PreUploadNotificationTypes),
        _config_: z.any().optional(),
    });
    const PostUploadNotificationProcessSchema = z.object({
        notificationType: z.enum(DeliverablePropertyDEPRECATED.PostUploadNotificationTypes),
        _config_: z.any().optional(),
    });
    DeliverablePropertyDEPRECATED.ConfigSchema = z.object({
        configKey: z.string(),
        deliverableType: z.nativeEnum(Deliverable.v3DEPRECATED.DeliverableType),
        frequency: z.enum(Utils.FrequencyPeriod),
        dependencies: z.array(z.string()),
        partyPermissions: z.array(PartyPermissionSchema),
        preUploadNotificationProcesses: z.array(PreUploadNotificationProcessSchema),
        postUploadNotificationProcesses: z.array(PostUploadNotificationProcessSchema),
    });
})(DeliverablePropertyDEPRECATED || (exports.DeliverablePropertyDEPRECATED = DeliverablePropertyDEPRECATED = {}));
var DeliverableReportProperty;
(function (DeliverableReportProperty) {
    DeliverableReportProperty.ConfigSchema = z.object({
        processOnUpload: z.array(z.enum(Report.UploadDownstreamProcess)),
    });
})(DeliverableReportProperty || (exports.DeliverableReportProperty = DeliverableReportProperty = {}));
/**
 * ============= ELIGIBILITY TEST =============
 */
var EligibilityTest;
(function (EligibilityTest) {
    // Zod schema for EligibilityCriteriaCalculation
    EligibilityTest.EligibilityCriteriaCalculationSchema = z.object({
        eligibilityCriteriaKey: z.string(),
        eligibilityReduction: z.number(),
    });
    // Zod schemas for EligibilityTest.Config (discriminated union)
    const PointerConfigSchema = z.object({
        method: z.string(),
    });
    const FormulaTestSchema = z.object({
        propertyKey: z.string(),
        type: z.literal('formula'),
        config: exports.FormulaConfigSchema,
    });
    const PointerTestSchema = z.object({
        propertyKey: z.string(),
        type: z.literal('pointer'),
        config: PointerConfigSchema,
    });
    EligibilityTest.ConfigSchema = z.discriminatedUnion('type', [
        FormulaTestSchema,
        PointerTestSchema,
    ]);
})(EligibilityTest || (exports.EligibilityTest = EligibilityTest = {}));
/**
 * ============= CONCENTRATION LIMIT =============
 */
var ConcentrationLimit;
(function (ConcentrationLimit) {
    /**
     * ============= VALUE CONFIG =============
     */
    let Value;
    (function (Value) {
        // for normalizing a number or currency type to a percentage type in standard calculation
        Value.ValueTypeIterable = [
            'currency',
            'number',
            'percentage',
        ];
    })(Value = ConcentrationLimit.Value || (ConcentrationLimit.Value = {}));
    let Calculation;
    (function (Calculation) {
        Calculation.DeclarativeConfigIterable = [
            'weightedAverage',
            'standard',
            'exposureByGroup',
            'directInsert',
        ];
        Calculation.SourceConfigIterable = [
            'pointer',
            ...Calculation.DeclarativeConfigIterable,
        ];
        Calculation.ResolvedConfigIterable = [
            'resolvedPointer',
            ...Calculation.DeclarativeConfigIterable,
        ];
        Calculation.LimitTypeIterable = ['min', 'max'];
        let Filters;
        (function (Filters) {
            Filters.OrderByOperatorIterable = ['asc', 'desc'];
            Filters.InListConfigIterable = ['inList', 'notInList'];
            Filters.EqualOperatorIterable = ['equals', 'notEqual'];
            Filters.CompareOperatorIterable = [
                'lessThan',
                'greaterThan',
                'greaterThanOrEqual',
                'lessThanOrEqual',
            ];
            Filters.OperationTypeIterable = [
                'orderBy',
                'orderBySum',
                'notEqual',
                'equals',
                'lessThan',
                'greaterThan',
                'greaterThanOrEqual',
                'lessThanOrEqual',
                'inList',
                'notInList',
            ];
        })(Filters = Calculation.Filters || (Calculation.Filters = {}));
        Calculation.WeightingIterable = [
            'eligibleExposureLessConcentrationKickout',
            'constant',
        ];
        // Zod schema for ConcentrationLimitCalculation (used in ReceivableResponseTape)
        Calculation.ConcentrationLimitCalculationSchema = z.object({
            concentrationLimitKey: z.string(),
            concentrationLimit: z.number(),
            concentrationAmount: z.number().nullable().optional(),
            totalEligibleExposure: z.number(),
            concentration: z.number(),
            borrowingBaseReduction: z.number(),
            complianceStatus: DbTables_1.ComplianceStatusSchema,
        });
    })(Calculation = ConcentrationLimit.Calculation || (ConcentrationLimit.Calculation = {}));
    // ============= ZOD SCHEMAS =============
    // Value.ConfigSchema
    ConcentrationLimit.ValueConfigSchema = z.object({
        type: z.literal('formula'),
        limit: z.string(),
        valueType: z.enum(Value.ValueTypeIterable),
    });
    // Calculation filter schemas
    const FilterCommonConfigSchema = z.object({
        applyToDenominator: z.boolean().optional(),
    });
    const OrderBySumConfigSchema = FilterCommonConfigSchema.extend({
        operation: z.literal('orderBySum'),
        field: z.string(),
        type: z.enum(['string', 'number']),
        groupBy: z.string(),
        count: z.number(),
        offset: z.number().optional(),
    });
    const OrderByConfigSchema = FilterCommonConfigSchema.extend({
        operation: z.literal('orderBy'),
        field: z.string(),
        count: z.number(),
        type: z.literal('number'),
        order: z.enum(Calculation.Filters.OrderByOperatorIterable).optional(),
    });
    const InListConfigSchema = FilterCommonConfigSchema.extend({
        field: z.string(),
        operation: z.enum(Calculation.Filters.InListConfigIterable),
        type: z.enum(['string', 'number', 'boolean']),
        list: z.array(z.any()).readonly(),
    });
    const EqualsConfigSchema = FilterCommonConfigSchema.extend({
        field: z.string(),
        operation: z.enum(Calculation.Filters.EqualOperatorIterable),
        value: z.any(),
        type: z.enum(['string', 'number', 'boolean']),
    });
    const CompareNumbersConfigSchema = FilterCommonConfigSchema.extend({
        field: z.string(),
        operation: z.enum(Calculation.Filters.CompareOperatorIterable),
        value: z.number(),
        type: z.literal('number'),
    });
    const FilterConfigSchema = z.union([
        OrderByConfigSchema,
        EqualsConfigSchema,
        OrderBySumConfigSchema,
        CompareNumbersConfigSchema,
        InListConfigSchema,
    ]);
    // Calculation config schemas
    const PointerConfigSchema = z.object({
        method: z.string(),
        filters: z.array(FilterConfigSchema).optional(),
    });
    const DeclarativeFilterWeightedAverageConfigSchema = z.object({
        field: z.string(),
        weighting: z.enum(Calculation.WeightingIterable),
        filters: z.array(FilterConfigSchema),
    });
    const DeclarativeFilterEligibleExposureBySingleFieldConfigSchema = z.object({
        groupingField: z.string(),
        fieldType: z.enum(['integer', 'string']),
        filters: z.array(FilterConfigSchema),
    });
    const DirectInsertConfigSchema = z.object({
        kickoutValueField: z.string(),
        filters: z.array(FilterConfigSchema),
    });
    const DeclarativeFilterStandardConfigSchema = z.object({
        filters: z.array(FilterConfigSchema),
    });
    // Calculation method config schemas (discriminated union on 'type')
    const PointerMethodCalculationConfigSchema = z.object({
        type: z.literal('pointer'),
        config: PointerConfigSchema,
    });
    const DeclarativeFilterWeightedAverageCalculationConfigSchema = z.object({
        type: z.literal('weightedAverage'),
        limitType: z.enum(Calculation.LimitTypeIterable),
        config: DeclarativeFilterWeightedAverageConfigSchema,
    });
    const DeclarativeFilterStandardCalculationConfigSchema = z.object({
        type: z.literal('standard'),
        config: DeclarativeFilterStandardConfigSchema,
    });
    const DeclarativeFilterEligibleExposureBySingleFieldCalculationConfigSchema = z.object({
        type: z.literal('exposureByGroup'),
        config: DeclarativeFilterEligibleExposureBySingleFieldConfigSchema,
    });
    const DeclarativeDirectInsertConfigSchema = z.object({
        type: z.literal('directInsert'),
        config: DirectInsertConfigSchema,
    });
    // Calculation.SourceConfig schema
    ConcentrationLimit.CalculationSourceConfigSchema = z.discriminatedUnion('type', [
        PointerMethodCalculationConfigSchema,
        DeclarativeFilterWeightedAverageCalculationConfigSchema,
        DeclarativeFilterStandardCalculationConfigSchema,
        DeclarativeFilterEligibleExposureBySingleFieldCalculationConfigSchema,
        DeclarativeDirectInsertConfigSchema,
    ]);
    // WaiveConfig schema
    const WaiveConfigSchema = z.object({
        reason: z.string(),
        config: exports.FormulaConfigSchema,
    });
    // ConcentrationLimit.SourceConfig schema
    ConcentrationLimit.SourceConfigSchema = z.object({
        propertyKey: z.string(),
        waiveConfigs: z.array(WaiveConfigSchema),
        calculationConfig: ConcentrationLimit.CalculationSourceConfigSchema.optional(),
        valueConfig: ConcentrationLimit.ValueConfigSchema,
    });
})(ConcentrationLimit || (exports.ConcentrationLimit = ConcentrationLimit = {}));
/**
 * ============================================
 * ======    GLOBAL RECURRING DATE     ========
 * ============================================
 *
 * This set up is to represent configs that will help generate
 * dynamic date lists based on our recurring date mechanics.
 * Currently being used by PortCovs & Reporting Mechanics
 */
var GlobalRecurringDate;
(function (GlobalRecurringDate) {
    GlobalRecurringDate.SetupTypeIterable = ['static', 'relative'];
    GlobalRecurringDate.SetupTypeSchema = z.enum(GlobalRecurringDate.SetupTypeIterable);
    GlobalRecurringDate.RecurringDateSetupConfigsSchema = z.union([
        Date_1.RecurringDate.ConfigSchema,
        Date_1.RecurringDate.RelativeConfigSchema,
    ]);
    // Compile-time assertion helper
    GlobalRecurringDate.StaticRecurringDateSetupSchema = z.object({
        type: z.literal('static'),
        config: Date_1.RecurringDate.ConfigSchema,
    });
    GlobalRecurringDate.RelativeRecurringDateSetupSchema = z.object({
        type: z.literal('relative'),
        config: Date_1.RecurringDate.RelativeConfigSchema,
        triggerDateFormula: z.string(),
    });
    GlobalRecurringDate.ConfigSchema = z.object({
        /**
         * This will represent the base "name" of the output variable.
         * Also will be attribute for other areas (Athena Queries) to reference
         */
        field: z.string(),
        setup: z.union([
            GlobalRecurringDate.StaticRecurringDateSetupSchema,
            GlobalRecurringDate.RelativeRecurringDateSetupSchema,
        ]),
        // Since we're allowing other areas to also utilize these fields, like
        // output template, and not just Athena queries, we'd ultimately want to
        // manage fallback (default) behavior here as well. That way, we can
        // pre-populate variables here based on "maxCount" so other references
        // would still be valid at time of generation
        maxCount: z.number(),
        defaultTo: z.object({
            value: z.string(),
            parseString: z.boolean(),
        }),
    });
})(GlobalRecurringDate || (exports.GlobalRecurringDate = GlobalRecurringDate = {}));
// Compile-time assertion helper
exports.QueryVariableSchema = z.object({
    name: z.string(),
    value: z.string(),
    parseNumber: z.boolean(),
});
// Compile-time assertion: verify Zod-inferred type matches original
exports.QueryResultSchema = z.object({
    name: z.string(),
    value: Utils.PrimitiveStruct.optional(),
});
/**
 * ============================================
 * =============    ATHENA     ================
 * ============================================
 */
// Zod schema for AthenaConfig.Query
exports.AthenaConfigQuerySchema = z.object({
    /** These variables can be used in binding formulas */
    variables: z.array(exports.QueryVariableSchema),
    /**
     * Elements to be bound to the queryString when generating SQL.
     * The order and quantity of elements matter since utilizing array!
     * Can consider updating this to use map with identifiers instead
     */
    bindings: z.array(z.string()),
    /** Athena "queryString" that is parameterized with '?' and uses "bindings" */
    query: z.object({
        name: z.string(),
        queryString: z.string(),
    }),
    /**
     * These columnNames are the output from after running the query.
     * They will be made available for later references (e.g., intermediate fields)
     */
    columnNames: z.array(z.string()),
});
// Zod schema for AthenaConfig.RecurringQuery
exports.AthenaConfigRecurringQuerySchema = z.object({
    /** Name that would be used for the variable outputs */
    name: z.string(),
    /**
     * This would house "field" value from "globalRecurringDateConfigs" to help
     * denote which one it is referencing to use at time of generation
     */
    globalRecurringDateConfigFields: z.array(z.string()),
    variables: z.array(exports.QueryVariableSchema),
    /**
     * For recurring dates: can just directly reference the "field" that is
     * set in "globalRecurringDateConfigs" and utilize that "field" as just
     * a normal variable.
     */
    bindings: z.array(z.string()),
    /**
     * Continuing with above example, can simply set string like:
     * SELECT date, exposure from TABLE where reportingDate = ?
     */
    queryString: z.string(),
    /**
     * Same attribute as normal "query", this helps with eagerly storing the columnNames,
     * which ultimately become the variable outputs of the query for subsequent references.
     */
    columnNames: z.array(z.string()),
    /**
     * Note that this "defaultTo" will apply to all the columns if
     * a recurringDate index doesn't exist.
     */
    defaultTo: z.object({
        value: z.string(),
        parseString: z.boolean(),
    }),
});
// Zod schema for Reporting.Inputs.IntermediateField
const CalcFormulaConfigSchema = exports.FormulaConfigSchema.extend({
    type: z.literal('formula'),
});
exports.ReportingInputsIntermediateFieldSchema = z.object({
    field: z.string(),
    config: CalcFormulaConfigSchema,
});
/**
 * ============================================
 *            COMMON FACILITY METRICS QUERY
 * ============================================
 *
 * Currently being used by accrued liabilities and reserve
 *
 * TODO: @sachinr4 to consolidate with CommonPostgresQuery
 */
var CommonFacilityMetricsQuery;
(function (CommonFacilityMetricsQuery) {
    // *********************************************
    //        FINAL FACILITY METRICS QUERY STRUCTURES
    // *********************************************
    let Query;
    (function (Query) {
        Query.FacilityMetricsQueryTypeIterable = [
            'commitmentAmount',
            'unusedCommitment',
            'principalBalance',
            'interestRate',
            'receivableExposure',
            'receivableRepayment',
        ];
    })(Query = CommonFacilityMetricsQuery.Query || (CommonFacilityMetricsQuery.Query = {}));
})(CommonFacilityMetricsQuery || (exports.CommonFacilityMetricsQuery = CommonFacilityMetricsQuery = {}));
/**
 * ============================================
 *            COMMON POSTGRES QUERY
 * ============================================
 *
 * Currently being used by Portfolio Covenants, Financial Covenants, Reporting
 */
var CommonPostgresQuery;
(function (CommonPostgresQuery) {
    // *********************************************
    //        FINAL POSTGRES QUERY STRUCTURES
    // *********************************************
    let Query;
    (function (Query) {
        Query.PostgresQueryTypeIterable = [
            'assetVerification',
            'principalBalanceDailyAverage',
            'principalBalancePointInTime',
            'tAccountsSum',
            'orgProvidedInput',
        ];
    })(Query = CommonPostgresQuery.Query || (CommonPostgresQuery.Query = {}));
})(CommonPostgresQuery || (exports.CommonPostgresQuery = CommonPostgresQuery = {}));
// ============================================
// Zod schemas for CommonPostgresQuery types
// ============================================
// ParameterConfig schemas
exports.PostgresParameterFormulaConfigSchema = z.object({
    type: z.literal('formula'),
    engineVersion: z.enum(FormulaEngine.SupportedFormulaEngines),
    formula: z.string(),
});
exports.PostgresParameterAssetVerificationStatusConfigSchema = z.object({
    type: z.literal('assetVerificationStatusArray'),
    statuses: z.array(z.enum(AssetVerification.AssetVerificationOutput.ReportEntryStatusIterable)),
});
exports.PostgresParameterCapitalProviderSlugsConfigSchema = z.object({
    type: z.literal('capitalProviderSlugArray'),
    slugs: z.array(z.string()),
});
exports.PostgresParameterTAccountsSumConfigSchema = z.object({
    type: z.literal('tAccountDetailsArray'),
    accountDetails: z.array(z.object({
        counterpartySlug: z.string(),
        tAccount: z.string(),
    })),
});
exports.PostgresParameterOrgProvidedInputKeyConfigSchema = z.object({
    type: z.literal('orgProvidedInputKey'),
    key: z.string(),
});
exports.PostgresParameterReportingPeriodConfigSchema = z.object({
    type: z.literal('reportingPeriod'),
    reportingPeriod: Date_1.Reporting.ReportingPeriodSchema,
});
// Config schemas (used in Query parameterConfig)
const AssetVerificationQueryConfigSchema = z.object({
    statusFilter: exports.PostgresParameterAssetVerificationStatusConfigSchema,
});
const PrincipalBalancePointInTimeQueryConfigSchema = z.object({
    dateFormula: exports.PostgresParameterFormulaConfigSchema,
});
const PrincipalBalanceDailyAverageQueryConfigSchema = z.object({
    startDateFormula: exports.PostgresParameterFormulaConfigSchema,
    endDateFormula: exports.PostgresParameterFormulaConfigSchema,
    capitalProviderSlugs: exports.PostgresParameterCapitalProviderSlugsConfigSchema,
});
const TAccountsSumQueryConfigSchema = z.object({
    startDateFormula: exports.PostgresParameterFormulaConfigSchema,
    endDateFormula: exports.PostgresParameterFormulaConfigSchema,
    tAccountDetails: exports.PostgresParameterTAccountsSumConfigSchema,
});
const OrgProvidedInputQueryConfigSchema = z.object({
    reportingDateFormula: exports.PostgresParameterFormulaConfigSchema,
    reportingPeriod: exports.PostgresParameterReportingPeriodConfigSchema,
    key: exports.PostgresParameterOrgProvidedInputKeyConfigSchema,
});
// Query schemas
const BasePostgresQuerySchema = z.object({
    name: z.string(),
    variables: z.array(exports.QueryVariableSchema),
});
exports.PrincipalBalancePointInTimeQuerySchema = BasePostgresQuerySchema.extend({
    type: z.literal('principalBalancePointInTime'),
    parameterConfig: PrincipalBalancePointInTimeQueryConfigSchema,
    resultType: z.literal('primitive'),
});
exports.PrincipalBalanceDailyAverageQuerySchema = BasePostgresQuerySchema.extend({
    type: z.literal('principalBalanceDailyAverage'),
    parameterConfig: PrincipalBalanceDailyAverageQueryConfigSchema,
    resultType: z.literal('primitive'),
});
exports.TAccountsSumQuerySchema = BasePostgresQuerySchema.extend({
    type: z.literal('tAccountsSum'),
    parameterConfig: TAccountsSumQueryConfigSchema,
    resultType: z.literal('primitive'),
});
exports.OrgProvidedInputQuerySchema = BasePostgresQuerySchema.extend({
    type: z.literal('orgProvidedInput'),
    parameterConfig: OrgProvidedInputQueryConfigSchema,
    resultType: z.literal('primitive'),
});
exports.AssetVerificationQuerySchema = BasePostgresQuerySchema.extend({
    type: z.literal('assetVerification'),
    parameterConfig: AssetVerificationQueryConfigSchema,
    resultType: z.literal('array'),
});
// Union schema for all postgres queries used by FinancialCovenant
exports.FinancialCovenantPostgresQuerySchema = z.discriminatedUnion('type', [
    exports.PrincipalBalancePointInTimeQuerySchema,
    exports.PrincipalBalanceDailyAverageQuerySchema,
    exports.TAccountsSumQuerySchema,
    exports.OrgProvidedInputQuerySchema,
]);
// Zod schema for CommonIntermediateField.IntermediateField
// Reuses the CalcFormulaConfigSchema defined above for ReportingInputsIntermediateFieldSchema
exports.CommonIntermediateFieldSchema = z.object({
    field: z.string(),
    config: exports.FormulaConfigSchema.extend({ type: z.literal('formula') }),
});
/**
 * Portfolio Covenants operate generically in the following manner:
 *
 * Queries (Athena and Postgres) have variables that are primitives.
 * There is a special runtime variable `triggerDate` that always injected into the variable list.
 *
 * These variables can be then used in formulas to determine what parameterized values should be passed to a query implementation.
 * A common pattern will be to have `triggerDate` variable passed to a formula to determine `startDate` of a query
 * ie. startDate is the first of day of the previous month relative to the triggerDate
 *
 * The resulting evaluation of the formulas are then passed as parameters to the query implementation.
 * Postgres queries will pass as params to a method as there may be additional application logic.
 * Athena params are simply bound to the query with `?` binding pattern.
 *
 * The results of the athena or pg query are then made available to the intermediate fields (formula) from further evaluation.
 *
 * Athena results will be the first row of the resulting query, accessible by queryName.columnName in intermediate fields
 * ColumnNames are eagerly stored/validated in the config, unexpected column names are omitted in the response.
 *
 * Postgres results will resolve to singular primitive (application code wrapping the pg query will handle this), accessible by `name` in intermediate fields.
 *
 */
var PortfolioCovenant;
(function (PortfolioCovenant) {
    PortfolioCovenant.ValueTypes = ['currency', 'ratio', 'percentage'];
    /**
     * *** POSTGRES QUERIES ***
     */
    let PostgresQuery;
    (function (PostgresQuery) {
        PostgresQuery.QueryTypeIterable = [
            'principalBalanceDailyAverage',
            'principalBalancePointInTime',
            'tAccountsSum',
            'orgProvidedInput',
        ];
    })(PostgresQuery = PortfolioCovenant.PostgresQuery || (PortfolioCovenant.PostgresQuery = {}));
    /**
     * *** INTERMEDIATE FIELDS ***
     */
    PortfolioCovenant.RequiredIntermediateFieldIterable = [
        'triggerDate',
        'portfolioCovenantValue',
        'portfolioCovenantResult',
        'portfolioCovenantReportingDate',
    ];
    /**
     * *** MAIN CONFIG ***
     */
    PortfolioCovenant.ConfigSchema = z.object({
        valueType: z.enum(PortfolioCovenant.ValueTypes),
        triggerDates: Date_1.RecurringDate.ConfigSchema,
        globalRecurringDateConfigs: z.array(GlobalRecurringDate.ConfigSchema),
        athenaQueries: z.array(exports.AthenaConfigQuerySchema),
        athenaRecurringQueries: z.array(exports.AthenaConfigRecurringQuerySchema),
        // PortfolioCovenant.PostgresQuery.Query has same structure as FinancialCovenant.PostgresQuery.Query
        postgresQueries: z.array(exports.FinancialCovenantPostgresQuerySchema),
        intermediateFields: z.array(exports.CommonIntermediateFieldSchema),
    });
})(PortfolioCovenant || (exports.PortfolioCovenant = PortfolioCovenant = {}));
/**
 * ============================================
 *             FINANCIAL COVENANTS
 * ============================================
 */
var FinancialCovenant;
(function (FinancialCovenant) {
    let LimitValueType;
    (function (LimitValueType) {
        LimitValueType["currency"] = "currency";
        LimitValueType["ratio"] = "ratio";
        LimitValueType["percentage"] = "percentage";
    })(LimitValueType = FinancialCovenant.LimitValueType || (FinancialCovenant.LimitValueType = {}));
    let LimitType;
    (function (LimitType) {
        LimitType["Min"] = "min";
        LimitType["Max"] = "max";
    })(LimitType = FinancialCovenant.LimitType || (FinancialCovenant.LimitType = {}));
    /**
     * *** POSTGRES QUERIES ***
     */
    let PostgresQuery;
    (function (PostgresQuery) {
        PostgresQuery.QueryTypeIterable = [
            'principalBalanceDailyAverage',
            'principalBalancePointInTime',
            'tAccountsSum',
            'orgProvidedInput',
        ];
    })(PostgresQuery = FinancialCovenant.PostgresQuery || (FinancialCovenant.PostgresQuery = {}));
    /**
     * *** INTERMEDIATE FIELDS ***
     */
    FinancialCovenant.RequiredIntermediateFieldIterable = [
        'triggerDate',
        'financialCovenantReportingDate',
        'financialCovenantValue',
        'financialCovenantResult',
    ];
    /**
     * *** CONFIG ***
     */
    FinancialCovenant.ConfigSchema = z.object({
        triggerDates: Date_1.RecurringDate.ConfigSchema,
        globalRecurringDateConfigs: z.array(GlobalRecurringDate.ConfigSchema),
        athenaQueries: z.array(exports.AthenaConfigQuerySchema),
        athenaRecurringQueries: z.array(exports.AthenaConfigRecurringQuerySchema),
        postgresQueries: z.array(exports.FinancialCovenantPostgresQuerySchema),
        intermediateFields: z.array(exports.CommonIntermediateFieldSchema),
    });
})(FinancialCovenant || (exports.FinancialCovenant = FinancialCovenant = {}));
/**
 * ============================================
 * =============   REPORTING   ================
 * ============================================
 */
var Reporting;
(function (Reporting) {
    /**
     * *** POSTGRES QUERIES ***
     */
    let PostgresQuery;
    (function (PostgresQuery) {
        PostgresQuery.QueryArrayResultTypeIterable = ['assetVerification'];
    })(PostgresQuery = Reporting.PostgresQuery || (Reporting.PostgresQuery = {}));
    /**
     * *** SHARED COLUMN CONFIG ***
     * Shared column configuration schemas used by both Inputs (fileInsertAthenaQueries)
     * and Outputs.Docx (file insertion configs)
     */
    let ColumnConfig;
    (function (ColumnConfig) {
        ColumnConfig.CurrencyColumnConfigSchema = z.object({
            type: z.literal('currency'),
            format: z.enum(Utils.CurrencyFormatIterable),
            name: z.string(),
            propertyName: z.string(),
            order: z.number(),
        });
        ColumnConfig.DateColumnConfigSchema = z.object({
            type: z.literal('date'),
            format: z.string(),
            name: z.string(),
            propertyName: z.string(),
            order: z.number(),
        });
        ColumnConfig.PercentageColumnConfigSchema = z.object({
            type: z.literal('percentage'),
            format: z.enum(Utils.PercentageFormatIterable),
            name: z.string(),
            propertyName: z.string(),
            order: z.number(),
        });
        ColumnConfig.TextColumnConfigSchema = z.object({
            type: z.literal('text'),
            format: z.enum(Utils.TextFormatIterable),
            name: z.string(),
            propertyName: z.string(),
            order: z.number(),
        });
        ColumnConfig.Schema = z.discriminatedUnion('type', [
            ColumnConfig.CurrencyColumnConfigSchema,
            ColumnConfig.DateColumnConfigSchema,
            ColumnConfig.PercentageColumnConfigSchema,
            ColumnConfig.TextColumnConfigSchema,
        ]);
    })(ColumnConfig = Reporting.ColumnConfig || (Reporting.ColumnConfig = {}));
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   DATA ACCESSOR   ************
        let DataAccessor;
        (function (DataAccessor) {
            DataAccessor.Methods = [
                'accruedLiabilities',
                'borrowingBaseMetrics',
                'creditAgreementMetrics',
                'fundingRequestMetrics',
                'invoiceMetrics',
                'loanMetrics',
                'orgProvidedInputs',
                'portfolioCovenantResults',
                'financialCovenantResults',
            ];
            /**
             * These basically represent pointer methods to existing domain controller / accessors
             */
            // Zod schemas for DataAccessor types
            DataAccessor.FormulaParameterConfigSchema = z.object({
                type: z.literal('formula'),
                params: exports.FormulaConfigSchema,
            });
            DataAccessor.ReportingPeriodParameterConfigSchema = z.object({
                type: z.literal('reportingPeriod'),
                params: Date_1.Reporting.ReportingPeriodSchema,
            });
            // Config schemas for each accessor type
            const AccruedLiabilitiesConfigSchema = z.object({
                startDateFormula: DataAccessor.FormulaParameterConfigSchema,
                endDateFormula: DataAccessor.FormulaParameterConfigSchema,
                requiresLatestStatementForPeriod: z.boolean().optional(),
            });
            const BorrowingBaseMetricsConfigSchema = z.object({
                reportingDateFormula: DataAccessor.FormulaParameterConfigSchema,
                reportingPeriod: DataAccessor.ReportingPeriodParameterConfigSchema,
            });
            const FundingRequestMetricsConfigSchema = z.object({
                reportingDateFormula: DataAccessor.FormulaParameterConfigSchema,
                reportingPeriod: DataAccessor.ReportingPeriodParameterConfigSchema,
            });
            const OrgProvidedInputsConfigSchema = z.object({
                reportingDateFormula: DataAccessor.FormulaParameterConfigSchema,
                reportingPeriod: DataAccessor.ReportingPeriodParameterConfigSchema,
            });
            const PortfolioCovenantResultsConfigSchema = z.object({
                reportingDateFormula: DataAccessor.FormulaParameterConfigSchema,
                reportingPeriod: DataAccessor.ReportingPeriodParameterConfigSchema,
            });
            const FinancialCovenantResultsConfigSchema = z.object({
                reportingDateFormula: DataAccessor.FormulaParameterConfigSchema,
                reportingPeriod: DataAccessor.ReportingPeriodParameterConfigSchema,
            });
            // Accessor schemas
            const AccruedLiabilitiesAccessorSchema = z.object({
                method: z.literal('accruedLiabilities'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: AccruedLiabilitiesConfigSchema,
            });
            const BorrowingBaseMetricsAccessorSchema = z.object({
                method: z.literal('borrowingBaseMetrics'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: BorrowingBaseMetricsConfigSchema,
            });
            const CreditAgreementMetricsAccessorSchema = z.object({
                method: z.literal('creditAgreementMetrics'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: z.null(),
            });
            const InvoiceMetricsAccessorSchema = z.object({
                method: z.literal('invoiceMetrics'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: z.null(),
            });
            const LoanMetricsAccessorSchema = z.object({
                method: z.literal('loanMetrics'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: z.null(),
            });
            const FundingRequestMetricsAccessorSchema = z.object({
                method: z.literal('fundingRequestMetrics'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: FundingRequestMetricsConfigSchema,
            });
            const OrgProvidedInputsAccessorSchema = z.object({
                method: z.literal('orgProvidedInputs'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: OrgProvidedInputsConfigSchema,
            });
            const PortfolioCovenantResultsAccessorSchema = z.object({
                method: z.literal('portfolioCovenantResults'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: PortfolioCovenantResultsConfigSchema,
            });
            const FinancialCovenantResultsAccessorSchema = z.object({
                method: z.literal('financialCovenantResults'),
                name: z.string(),
                variables: z.array(exports.QueryVariableSchema),
                parameterConfig: FinancialCovenantResultsConfigSchema,
            });
            DataAccessor.AccessorSchema = z.discriminatedUnion('method', [
                AccruedLiabilitiesAccessorSchema,
                BorrowingBaseMetricsAccessorSchema,
                CreditAgreementMetricsAccessorSchema,
                InvoiceMetricsAccessorSchema,
                LoanMetricsAccessorSchema,
                FundingRequestMetricsAccessorSchema,
                OrgProvidedInputsAccessorSchema,
                PortfolioCovenantResultsAccessorSchema,
                FinancialCovenantResultsAccessorSchema,
            ]);
        })(DataAccessor = Inputs.DataAccessor || (Inputs.DataAccessor = {}));
        // ************   CONFIG   ************
        /**
         * In general, Athena & DataAccessor (Postgres) act as gateways to our persistent data.
         * Intermediate fields are outputs from layering on calculations to these source data.
         * The evaluation flow would follow:
         * globalRecurringDateConfigs --> Athena | DataAccessor --> Intermediate Fields
         *
         * These "inputs" basically represent variables that would be made available for
         * the output sheets to utilize
         */
        // File Insert Athena Query schema - used for xlsx file insertion
        Inputs.FileInsertAthenaQuerySchema = exports.AthenaConfigQuerySchema.extend({
            columns: z.array(ColumnConfig.Schema),
        });
        // Zod schema for Config
        Inputs.ConfigSchema = z.object({
            globalRecurringDateConfigs: z.array(GlobalRecurringDate.ConfigSchema),
            athenaQueries: z.array(exports.AthenaConfigQuerySchema),
            athenaRecurringQueries: z.array(exports.AthenaConfigRecurringQuerySchema),
            dataAccessors: z.array(DataAccessor.AccessorSchema),
            intermediateFields: z.array(exports.ReportingInputsIntermediateFieldSchema),
            fileInsertAthenaQueries: z.array(Inputs.FileInsertAthenaQuerySchema).optional(),
        });
    })(Inputs = Reporting.Inputs || (Reporting.Inputs = {}));
    // ========   OUTPUTS   ========
    let Outputs;
    (function (Outputs) {
        let Docx;
        (function (Docx) {
            // *******************************
            // ***  File Insertion Config  ***
            // *******************************
            Docx.FileInsertionTypeIterable = [
                'athenaQuery',
                'postgresQuery',
            ];
            // Re-export from shared ColumnConfig namespace
            Docx.CurrencyColumnConfigSchema = ColumnConfig.CurrencyColumnConfigSchema;
            Docx.DateColumnConfigSchema = ColumnConfig.DateColumnConfigSchema;
            Docx.PercentageColumnConfigSchema = ColumnConfig.PercentageColumnConfigSchema;
            Docx.TextColumnConfigSchema = ColumnConfig.TextColumnConfigSchema;
            Docx.ColumnConfigSchema = ColumnConfig.Schema;
            // Zod schemas for FileInsertion types
            const AbstractFileInsertionConfigSchema = z.object({
                loanProductId: z.string().optional(),
                reportingDateFormula: z.string(),
                columns: z.array(Docx.ColumnConfigSchema),
            });
            Docx.AthenaQueryFileInsertionConfigSchema = AbstractFileInsertionConfigSchema.extend({
                fileType: z.literal('athenaQuery'),
                athenaQuery: exports.AthenaConfigQuerySchema,
            });
            Docx.PostgresQueryFileInsertionConfigSchema = AbstractFileInsertionConfigSchema.extend({
                fileType: z.literal('postgresQuery'),
                postgresQuery: exports.AssetVerificationQuerySchema,
            });
            Docx.FileInsertionConfigSchema = z.discriminatedUnion('fileType', [
                Docx.AthenaQueryFileInsertionConfigSchema,
                Docx.PostgresQueryFileInsertionConfigSchema,
            ]);
            Docx.FileInsertionOutputSchema = z.object({
                name: z.string(),
                type: z.literal('fileInsertion'),
                config: Docx.FileInsertionConfigSchema,
            });
            // Compile-time assertion for FileInsertionOutput
            // Zod schema for FundingRequestComponentConfig
            Docx.FundingRequestComponentConfigSchema = z.object({
                collectionsPaydown: z.boolean(),
                collectionsRecycle: z.boolean(),
                curePaydown: z.boolean(),
                drawRequest: z.boolean(),
            });
            // Zod schema for TemplateConfig (inline to avoid forward reference)
            const DocxTemplateConfigSchema = z.object({
                name: z.string(),
                s3Path: z.string(),
            });
            // Zod schema for Docx.Config
            Docx.ConfigSchema = z.object({
                name: z.string(),
                template: DocxTemplateConfigSchema.optional(),
                fundingRequestComponents: Docx.FundingRequestComponentConfigSchema.optional(),
                data: z.array(Docx.FileInsertionOutputSchema).optional(),
            });
            // Compile-time assertion for Config
        })(Docx = Outputs.Docx || (Outputs.Docx = {}));
        let Xlsx;
        (function (Xlsx) {
            Xlsx.DataOutputTypeIterable = [
                'dataCellObject',
                'fileInsertion',
                'imageFileInsertion',
            ];
            // *******************************
            // ***  File Insertion Config  ***
            // *******************************
            Xlsx.FileInsertionTypeIterable = [
                'rawMasterLoanTape',
                'rawAssignedLoanTape',
                'rawCovenantLoanTape',
                'rawRepaymentTape',
                'rawSupplementalTape',
                'generatedMasterLoanTape',
                'generatedAssignedLoanTape',
                'generatedCovenantLoanTape',
                'generatedRepaymentTape',
                'generatedSupplementalTape',
                'intermediateTape',
                'extendedResponseTape',
                'newlyAssignedExtendedResponseTape',
                'borrowingBaseReserve',
                'statementDailySummary',
                'bankAccountScreenshot',
                'athenaQuery',
            ];
            // Zod schemas for Xlsx types
            const NumberCoordinatesSchema = z.object({
                row: z.number(),
                column: z.number(),
            });
            const DataCellObjectSchema = z.object({
                excelCoordinate: z.string(),
                numberCoordinates: NumberCoordinatesSchema,
                value: Utils.PrimitiveStruct,
            });
            const DataCellObjectConfigSchema = z.object({
                data: z.array(DataCellObjectSchema),
            });
            // FileInsertionType without 'statementDailySummary'
            const FileInsertionTypeDefaultIterable = [
                'rawMasterLoanTape',
                'rawAssignedLoanTape',
                'rawCovenantLoanTape',
                'rawRepaymentTape',
                'rawSupplementalTape',
                'generatedMasterLoanTape',
                'generatedAssignedLoanTape',
                'generatedCovenantLoanTape',
                'generatedRepaymentTape',
                'generatedSupplementalTape',
                'intermediateTape',
                'extendedResponseTape',
                'newlyAssignedExtendedResponseTape',
                'borrowingBaseReserve',
                'bankAccountScreenshot',
            ];
            const BaseFileInsertionConfigSchema = z.object({
                loanProductId: z.string().optional(),
                reportingDateFormula: z.string(),
                startingExcelCoordinate: z.string(),
                artifactSlug: z.string().optional(),
                bankAccountId: z.string().optional(),
            });
            const FileInsertionConfigDefaultSchema = BaseFileInsertionConfigSchema.extend({
                fileType: z.enum(FileInsertionTypeDefaultIterable),
            });
            const FileInsertionConfigStatementDailySummarySchema = BaseFileInsertionConfigSchema.extend({
                loanProductId: z.never().optional(), // Matches `loanProductId?: never`
                fileType: z.literal('statementDailySummary'),
                requiresLatestStatementForPeriod: z.boolean(),
                statementStartDateFormula: z.string(),
                statementEndDateFormula: z.string(),
            });
            Xlsx.XlsxAthenaQueryFileInsertionConfigSchema = BaseFileInsertionConfigSchema.extend({
                loanProductId: z.never().optional(),
                fileType: z.literal('athenaQuery'),
                athenaQueryName: z.string(),
            });
            Xlsx.isAthenaQueryFileInsertionConfig = (config) => Xlsx.XlsxAthenaQueryFileInsertionConfigSchema.safeParse(config).success;
            Xlsx.XlsxFileInsertionConfigSchema = z.discriminatedUnion('fileType', [
                FileInsertionConfigDefaultSchema,
                FileInsertionConfigStatementDailySummarySchema,
                Xlsx.XlsxAthenaQueryFileInsertionConfigSchema,
            ]);
            // Output schemas
            const DataCellObjectOutputSchema = z.object({
                name: z.string(),
                type: z.literal('dataCellObject'),
                config: DataCellObjectConfigSchema,
            });
            const XlsxFileInsertionOutputSchema = z.object({
                name: z.string(),
                type: z.literal('fileInsertion'),
                config: Xlsx.XlsxFileInsertionConfigSchema,
            });
            const ImageFileInsertionOutputSchema = z.object({
                name: z.string(),
                type: z.literal('imageFileInsertion'),
                config: Xlsx.XlsxFileInsertionConfigSchema,
            });
            Xlsx.DataSheetOutputSchema = z.discriminatedUnion('type', [
                DataCellObjectOutputSchema,
                XlsxFileInsertionOutputSchema,
                ImageFileInsertionOutputSchema,
            ]);
            // Compile-time assertion for DataSheetOutput
            /**
             * Output config generally represents high-level XLSX workbook.
             * "template" is optional - where if present, data output will mutate / populate values
             * based on the template, otherwise, will look to create own raw file
             */
            // Inline TemplateConfig schema to avoid forward reference
            const XlsxTemplateConfigSchema = z.object({
                name: z.string(),
                s3Path: z.string(),
            });
            Xlsx.ConfigSchema = z.object({
                name: z.string(),
                sheets: z.array(Xlsx.DataSheetOutputSchema),
                template: XlsxTemplateConfigSchema.optional(),
            });
            // Compile-time assertion for Config
        })(Xlsx = Outputs.Xlsx || (Outputs.Xlsx = {}));
        /**
         * Optional parameter that will help house the configuration (location) of the
         * template that can be referenced during the output formation
         */
        Outputs.TemplateConfigSchema = z.object({
            name: z.string(),
            s3Path: z.string(),
        });
    })(Outputs = Reporting.Outputs || (Reporting.Outputs = {}));
    // ========   MAIN   ========
    Reporting.ReportTemplateFileTypeIterable = [
        'docx',
        'xlsx',
        'digital',
    ];
    // Zod schemas for Reporting.Config (discriminated union)
    const DocxConfigSchema = z.object({
        input: Inputs.ConfigSchema,
        type: z.literal('docx'),
        output: Outputs.Docx.ConfigSchema,
    });
    const XlsxConfigSchema = z.object({
        input: Inputs.ConfigSchema,
        type: z.literal('xlsx'),
        output: Outputs.Xlsx.ConfigSchema,
    });
    const DigitalConfigSchema = z.object({
        input: Inputs.ConfigSchema,
        type: z.literal('digital'),
    });
    Reporting.ConfigSchema = z.discriminatedUnion('type', [
        DocxConfigSchema,
        XlsxConfigSchema,
        DigitalConfigSchema,
    ]);
})(Reporting || (exports.Reporting = Reporting = {}));
/**
 * ============= PURCHASE PERCENTAGE RATE =============
 */
var PurchasePercentageRate;
(function (PurchasePercentageRate) {
    // Zod schemas for PurchasePercentageRate.Config
    const PointerConfigSchema = z.object({
        method: z.string(),
    });
    // Note: ResolvedPointerConfig includes pointerImplementation (a function),
    // which cannot be serialized to JSON. For Wire schema, we only need method.
    const FormulaSchema = z.object({
        type: z.literal('formula'),
        config: exports.FormulaConfigSchema,
    });
    const PointerMethodSchema = z.object({
        type: z.literal('pointer'),
        config: PointerConfigSchema.extend({
            // pointerImplementation is a function, use z.any() for JSON schema
            pointerImplementation: z.any().optional(),
        }),
    });
    PurchasePercentageRate.ConfigSchema = z.discriminatedUnion('type', [
        FormulaSchema,
        PointerMethodSchema,
    ]);
})(PurchasePercentageRate || (exports.PurchasePercentageRate = PurchasePercentageRate = {}));
/**
 * ============= RECEIVABLE VALUATION RATE =============
 */
var ReceivableValuationRate;
(function (ReceivableValuationRate) {
    // Zod schemas for ReceivableValuationRate.Config
    const PointerConfigSchema = z.object({
        method: z.string(),
    });
    const FormulaSchema = z.object({
        type: z.literal('formula'),
        config: exports.FormulaConfigSchema,
    });
    const PointerMethodSchema = z.object({
        type: z.literal('pointer'),
        config: PointerConfigSchema.extend({
            pointerImplementation: z.any().optional(),
        }),
    });
    ReceivableValuationRate.ConfigSchema = z.discriminatedUnion('type', [
        FormulaSchema,
        PointerMethodSchema,
    ]);
})(ReceivableValuationRate || (exports.ReceivableValuationRate = ReceivableValuationRate = {}));
/**
 * ============= RECEIVABLE ADVANCE RATE CONFIG =============
 */
var ReceivableAdvanceRate;
(function (ReceivableAdvanceRate) {
    ReceivableAdvanceRate.Types = ['formula', 'tree'];
    // Zod schemas for ReceivableAdvanceRate.Config
    // Note: The tree structures are recursive. For JSON schema generation,
    // we use z.any() for the recursive children since the full tree structure
    // is already well-defined in the existing JSON schema.
    // Simplified schema that captures the structure without recursive type complexity
    const AdvanceRateModifierNodeSchema = z.object({
        name: z.string(),
        isMatch: exports.FormulaConfigSchema,
        modifierFormula: exports.FormulaConfigSchema,
        children: z.array(z.any()), // Recursive: children are AdvanceRateModifierNode[]
    });
    const AdvanceRateNodeSchema = z.object({
        name: z.string(),
        isMatch: exports.FormulaConfigSchema,
        advanceRate: exports.FormulaConfigSchema,
        children: z.array(z.any()), // Recursive: children are AdvanceRateNode[]
        modifierNames: z.array(z.string()),
    });
    const FormulaSchema = z.object({
        type: z.literal('formula'),
        loanProductIds: z.array(z.string()),
        config: exports.FullFormulaConfigSchema,
    });
    const TreeSchema = z.object({
        type: z.literal('tree'),
        loanProductIds: z.array(z.string()),
        root: AdvanceRateNodeSchema,
        modifiers: z.array(AdvanceRateModifierNodeSchema),
    });
    ReceivableAdvanceRate.ConfigSchema = z.discriminatedUnion('type', [
        FormulaSchema,
        TreeSchema,
    ]);
})(ReceivableAdvanceRate || (exports.ReceivableAdvanceRate = ReceivableAdvanceRate = {}));
var LoanTapeField;
(function (LoanTapeField) {
    /**
     * ============= INTERMEDIATE CALCS =============
     */
    let IntermediateCalcs;
    (function (IntermediateCalcs) {
        // please ensure that this is subset of DataTapeField.Type
        IntermediateCalcs.ValidFieldTypes = [
            'integer',
            'optionalInteger',
            'string',
            'optionalString',
            'boolean',
            'optionalBoolean',
            'float',
            'optionalFloat',
            'date',
            'optionalDate',
            'percentage',
            'optionalPercentage',
        ];
        // Zod schema for IntermediateCalcContainer
        const CalcFormulaConfigSchema = exports.FormulaConfigSchema.extend({
            type: z.literal('formula'),
        });
        IntermediateCalcs.IntermediateCalcContainerSchema = z.object({
            field: z.string(),
            config: CalcFormulaConfigSchema,
            fieldType: z.enum(IntermediateCalcs.ValidFieldTypes),
        });
    })(IntermediateCalcs = LoanTapeField.IntermediateCalcs || (LoanTapeField.IntermediateCalcs = {}));
    // Zod schema for SignaledExternalAssignmentContainer
    LoanTapeField.SignaledExternalAssignmentContainerSchema = z.object({
        signaledExternalAssignmentField: z.string(),
        signaledExternalAssignment: z.string(),
    });
})(LoanTapeField || (exports.LoanTapeField = LoanTapeField = {}));
// Zod schema for ResolvedCalcAgentMechanicsConfig
exports.ResolvedCalcAgentMechanicsConfigSchema = z.object({
    concentrationKickoutMethod: z.enum(['waterfall', 'nonIterative']),
});
/**
 * ============= CASH ADVANCE RATE CONFIG =============
 */
var CashAdvanceRate;
(function (CashAdvanceRate) {
    const MethodTypeSchema = z.literal('formula');
    const AbstractConfigSchema = z.object({ type: MethodTypeSchema });
    const FormulaSchema = AbstractConfigSchema.extend({
        type: z.literal('formula'),
        config: exports.FullFormulaConfigSchema,
    });
    CashAdvanceRate.ConfigSchema = FormulaSchema;
})(CashAdvanceRate || (exports.CashAdvanceRate = CashAdvanceRate = {}));
/**
 * Maximum Prefunding Amount Config
 */
var MaximumPrefundingAmount;
(function (MaximumPrefundingAmount) {
    const MethodTypeSchema = z.literal('formula');
    const AbstractConfigSchema = z.object({ type: MethodTypeSchema });
    const AvailableFormulaFieldsSchema = z.object({
        commitmentAmount: z.optional(z.number()),
    });
    MaximumPrefundingAmount.ConfigSchema = AbstractConfigSchema.extend({
        type: z.literal('formula'),
        config: exports.FormulaConfigSchema,
    });
    // TO BE IMPLEMENTED LATER
    // | PointerConfig;
    // export type PointerConfig = AbstractConfig & {
    //   type: 'pointer';
    //   method: string;
    // };
    // after PointerConfig is fetched from database, it gets converted into ResolvedPointerConfig
    // by attaching the implementation to the method.
    // export type ResolvedPointerConfig = PointerConfig & {
    //   pointerImplementation: (
    //     conn: Knex
    //   ) => Promise<number>;
    // };
})(MaximumPrefundingAmount || (exports.MaximumPrefundingAmount = MaximumPrefundingAmount = {}));
/**
 * Commitment Amount Configuration
 */
var CommitmentAmount;
(function (CommitmentAmount) {
    CommitmentAmount.ConfigSchema = z.object({
        startDate: Utils.ZodFullDateStrStruct,
        endDate: Utils.ZodFullDateStrStruct,
        amount: z.number(),
    });
})(CommitmentAmount || (exports.CommitmentAmount = CommitmentAmount = {}));
/**
 * Account Configuration (for accruals and reserve)
 */
var Liabilities;
(function (Liabilities) {
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   INTERMEDIATE FIELDS   ************
        Inputs.RequiredIntermediateFieldIterable = z.enum([
            'accrualDate', // Represents the actual date of accrual, determined by accrual schedule
            'accrualValue', // Output used for final accrual amount
        ]);
        const CalcFormulaConfigSchema = exports.FormulaConfigSchema.and(z.object({ type: z.literal('formula') }));
        const IntermediateFieldSchema = z.object({
            field: z.string(),
            config: CalcFormulaConfigSchema,
        });
        // ************   CONFIG   ************
        // Multiple configurations can be applied as an array to the same account
        // Accrual dates act as separate segments using start/end date properties
        // i.e. Original config from date A -> B, then amended config from B -> C
        Inputs.ConfigSchema = z.object({
            accrualDates: Date_1.RecurringDate.ConfigSchema,
            dataAccessors: z.array(z.any()), // to be replaced
            intermediateFields: z.array(IntermediateFieldSchema),
        });
    })(Inputs = Liabilities.Inputs || (Liabilities.Inputs = {}));
    const ConfigSchema = z.object({
        inputConfigurations: z.array(Inputs.ConfigSchema),
    });
})(Liabilities || (exports.Liabilities = Liabilities = {}));
var Reserve;
(function (Reserve) {
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   INTERMEDIATE FIELDS   ************
        Inputs.RequiredIntermediateFieldIterable = [
            'reportingDate', // Provided by borrowing base report
            'collectionsCash', // Provided by borrowing base report
            'borrowingBaseReserve', // Expected output for borrowing base reserve
            'collectionsReserve', // Expected output for cash reserve (collections)
        ];
    })(Inputs = Reserve.Inputs || (Reserve.Inputs = {}));
})(Reserve || (exports.Reserve = Reserve = {}));
//# sourceMappingURL=Config.js.map